import { useState, useEffect } from 'react';
import { EditPage, EditPageTextField, EditPageCheckbox, EditPageSelect, EditPagePanel } from './../../common/EditPage';
import { create, getOne } from './../../common/v4/BackendProvider'
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const ClientCreate = () => {
    const [data, setData] = useState({ATRCREDLIM: 0.00, ATRCLIENTIDNUMBER: '', ATRSTATUS: true});
    const [metadata, setMetadata] = useState({});
    const navigate = useNavigate();

    useEffect(() => {
        getOne('/admin/clients/clients/', 'new').then(response => {
            setMetadata(response.data.metadata);
            setData({ ...data, ATRCLIENTIDNUMBER: response.data.metadata.nextClientId });
        });
    }, []);

    const handleSave = () => {
        create('/admin/clients/clients', {data: data}).then(response => {
            toast.success("Client created successfully", {});
            navigate('/clients/clients');
        }).catch(error => {
            toast.error("Error creating client: " + error.message, {});
        });
    }

    const handleCancel = () => {
        navigate('/clients/clients');
    }

    const onChange = (id, value) => {
        setData({ ...data, [id]: value });
    }

    return <div>
        <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            closeOnClick={true}
            pauseOnHover={true}
            draggable={true}
            progress="undefined"
        />
        <div className="row">
            <div className="col-md-12">
                <h2>Create Client</h2>
            </div>
        </div>
        <EditPage handleSave={ handleSave } handleCancel={ handleCancel } >
            <EditPagePanel>
                <EditPageTextField label="Client ID" id="ATRCLIENTIDNUMBER" onChange={ onChange } value={ data.ATRCLIENTIDNUMBER } />
                <EditPageTextField label="Name" id="ATRACCTNAME" onChange={ onChange } value={ data.ATRACCTNAME } />
                <EditPageTextField label="Company Name" id="ATRNAME" onChange={ onChange } value={ data.ATRNAME } />
                <EditPageCheckbox label="Enabled" id="ATRSTATUS" onChange={ onChange }  value={ data.ATRSTATUS } />
                <EditPageTextField label="Email Address" id="ATREMAIL" onChange={ onChange } value={ data.ATREMAIL } />
                <EditPageSelect label="Reseller" id="ATRRESELLERID" onChange={ onChange } value={ data.ATRRESELLERID }  options={ metadata.resellers?.values } />
                <EditPageSelect label="Currency" id="ATRCURID" onChange={ onChange } value={ data.ATRCURID }  options={ metadata.currencies?.values } />
                <EditPageTextField label="Balance" id="ATRBALANCE" disabled addonLeft={metadata.currency}  value={ data.ATRBALANCE } />
                <EditPageTextField label="Credit Limit" id="ATRCREDLIM"  addonLeft={metadata.currency} onChange={ onChange } value={ data.ATRCREDLIM } />
            </EditPagePanel>
            <EditPagePanel>
                <EditPageSelect label="Rate Profile" id="ATRPRODUCTID" onChange={ onChange } value={ data.ATRPRODUCTID }  options={ metadata.products?.values } />
                <EditPageTextField label="Discount" id="ATRDISCOUNT" addonLeft="%" onChange={ onChange }  value={ data.ATRDISCOUNT } />
                <EditPageSelect label="VAT Rate" id="ATRVATRATE" addonLeft="%" onChange={ onChange } value={ data.ATRVATRATE }  options={ metadata.vatrates?.values } />
                <EditPageSelect label="Simult. Calls" id="ATRSIMULT" onChange={ onChange } value={ data.ATRSIMULT }  options={ metadata.simcalls?.values } />
                <EditPageCheckbox label="Notify Low Balance" id="ATRNOTIFY" onChange={ onChange }  value={ data.ATRNOTIFY } />
                <EditPageTextField label="Notify Threshold" id="ATRLOWBALANCELEVEL"  addonLeft={metadata.currency} onChange={ onChange } value={ data.ATRLOWBALANCELEVEL } />
                <EditPageCheckbox label="Auto Invoicing" id="ATRINVMODE" onChange={ onChange }  value={ data.ATRINVMODE } />
                <EditPageSelect label="Payment Terms" nullable={ true } id="payment_term_id" onChange={ onChange } value={ data.payment_term_id } options={ metadata?.payment_terms?.values } />
                <EditPageSelect label="Invoice Template" nullable={ true } id="invoice_template_id" onChange={ onChange } value={ data.invoice_template_id } options={ metadata?.invoice_templates?.values } />
                <EditPageTextField label="Phone" id="ATRPHONE1" onChange={ onChange } value={ data.ATRPHONE1 } />
                <EditPageTextField label="Phone 2" id="ATRPHONE2" onChange={ onChange } value={ data.ATRPHONE2 } />
                <EditPageTextField label="Fax" id="ATRFAX" onChange={ onChange } value={ data.ATRFAX } />
            </EditPagePanel>
            <EditPagePanel>
                <EditPageTextField label="Address 1" id="ATRADDR1" onChange={ onChange } value={ data.ATRADDR1 } />
                <EditPageTextField label="Address 2" id="ATRADDR2" onChange={ onChange } value={ data.ATRADDR2 } />
                <EditPageTextField label="City" id="ATRCITY" onChange={ onChange } value={ data.ATRCITY } />
                <EditPageTextField label="State" id="ATRSTATE" onChange={ onChange } value={ data.ATRSTATE } />
                <EditPageTextField label="ZIP" id="ATRZIP" onChange={ onChange } value={ data.ATRZIP } />
                <EditPageSelect label="Country" id="ATRCOUNTRYID" onChange={ onChange } value={ data.ATRCOUNTRYID } options = { metadata.countries?.values } />
                <EditPageSelect label="EU VAT Country" id="ATREUVATCOUNTRY" onChange={ onChange } value={ data.ATREUVATCOUNTRY }  options = { metadata.euCountries?.values } />                       
                <EditPageTextField label="VAT Number" id="ATREUVATNUMBER" onChange={ onChange } value={ data.ATREUVATNUMBER } />
                <EditPageCheckbox label="VAT is valid" id="ATREUVATVALID" onChange={ onChange }  value={ data.ATREUVATVALID } />                    
                <EditPageTextField label="Billing Address 1" id="ATRBILLADDR1" onChange={ onChange } value={ data.ATRBILLADDR1 } />
                <EditPageTextField label="Billing Address 2" id="ATRBILLADDR2" onChange={ onChange } value={ data.ATRBILLADDR2 } />
                <EditPageTextField label="Billing City" id="ATRBILLCITY" onChange={ onChange } value={ data.ATRBILLCITY } />
                <EditPageTextField label="Billing State" id="ATRBILLSTATE" onChange={ onChange } value={ data.ATRBILLSTATE } />
                <EditPageTextField label="Billing ZIP" id="ATRBILLZIP" onChange={ onChange } value={ data.ATRBILLZIP } />
                <EditPageSelect label="Billing Country" id="ATRBILLCOUNTRYID" onChange={ onChange } value={ data.ATRBILLCOUNTRYID }  options = { metadata.countries?.values } />
            </EditPagePanel>
            <EditPagePanel>
            </EditPagePanel>
        </EditPage>
    </div>
}

export default ClientCreate;